import React from 'react'
import Link from 'gatsby-link'

import Home from '../components/Home/Home'

import colin from '../img/colinside.jpg'
import { ResponsiveH2 } from '../components/Title/Title'

const IndexPage = () => (
  <Home
    style={{
      background: `url(${colin}) center center no-repeat`,
    }}
  >
    <ResponsiveH2 breakpoint="920" max="75" min="36" uppercase>
      Colin Howeth
    </ResponsiveH2>
    <p style={{ marginTop: 10 }}>
      {' '}
      Developer/Software Engineer/Coder/Whatever.
    </p>
  </Home>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js